import { graphql } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import LinkArticle from '../components/LinkArticle';
import AngleRight from '../components/AngleRight';

import ventercenterBanner from '../images/news/venturecenter-banner.png';
import harrai from '../images/news/harrai.jpg';
import bankbeatLogoBanner from '../images/news/bankbeat-logo-banner.png';

import businesswire from '../images/news/businesswire.png';
import aft from '../images/news/aft.png';
import fintechbuzz from '../images/news/fintechbuzz.png';
import yahoofinance from '../images/news/yahoofinance.png';
import ap from '../images/news/ap.png';
import startupgrind from '../images/news/startupgrind.png';
import startupgrindBig from '../images/news/startupgrindBig.png';

const Section = styled.section`
	color: #34495e;
	position: relative;
	z-index: 1;
	padding: 2em ${(props) => props.theme.paddingMobile};

	@media(${(props) => props.theme.mediumUp}) {
		padding: 2em ${(props) => props.theme.paddingMediumUp};
	}


	& .row-flush {
		justify-content: space-between;
	}

	& article {
		padding-left: 0;
		padding-right: 0;

		&:nth-child(odd) {
			@media(${(props) => props.theme.mediumUp}) {
				padding-right: 1em;
			}

			@media(${(props) => props.theme.largeUp}) {
				padding-right: 2em;
			}
		}

		&:nth-child(even) {
			@media(${(props) => props.theme.mediumUp}) {
				padding-left: 1em;
			}

			@media(${(props) => props.theme.largeUp}) {
				padding-left: 2em;
			}
		}
	}

	& figure {
		padding-left: 0;
		padding-right: 0;

		img {
			border-radius: 10px;
		}
	}

	& h2 {
		width: 100%;
		color: #303c47;
		line-height: 1.2;
		padding-top: 0;
		margin-top: 0;
		color: ${(props) => props.theme.lightBlue};

		&.blue {
			font-size: 21px;
		}
	}


	& hr {
		margin: 1.5em auto;
		width: 60%;
	}

	& p {
		font-weight: 600;
		line-height: 1.3;
	}

	& a {
		font-weight: 900;
	}

	&.featured-stories article {
		margin-bottom: 4em;
	}

	&.featured-stories .row:last-child {
		margin-bottom: 0;
	}

`; // Section

const HeaderContent = styled.article`
	color: white;
	margin-top: 35px;

	& h1 {
		min-height: 0;
		margin-top: 1em;
	}

	@media(${(props) => props.theme.mediumUp}) {
		margin-top: 30px;
	}

	@media(${(props) => props.theme.largeUp}) {
		margin-top: 0px;
	}
`;

const NewsroomPage = (props: any) => {
	const {
		data: {
			site: {
				siteMetadata: { endpoint },
			},
		},
	} = props;

	const newsroomHeaderContent = <HeaderContent>
		<h1>Newsroom</h1>
		<p>Stay up on the latest news, featured<br />stories, and media from MK Decision.</p>
	</HeaderContent>;

	return <Layout
		pageTitle={'Newsroom'}
		metaDescription={'Press Releases and MK Decision in the News'}
		splashHeaderMinHeight={'457px'}
		headerSplashBgPositionLarge='bottom right'
		headerContent={newsroomHeaderContent}
		headerSplashBgAverageColor={'#34414c'}
		CenteredSplashWrapperClass='newspaper'
		BodyClass={'newsroom'}
	>
		<div className='centeredWrapper'>
			<Section className='news two-columns'>
				<h2 className='blue'>MK HAPPENINGS</h2>
				<div className='row row-flush'>

					<LinkArticle
						internalLink={false}
						href={'http://www.prweb.com/releases/mk_decision_selected_to_exhibit_at_2020_startup_grind_global_conference/prweb16887936.htm'}
						banner={startupgrindBig}
						bannerAlt={'Exhibiting at 2020 Startup Grind'}
						heading={'MK Decision Selected to Exhibit at 2020 Startup Grind Global Conference'}
						date={'Feb 6, 2020'}
						paragraph={'Innovative fintech showcases digital lending platform to attendees from around the world.'}
					/>



					<LinkArticle
						internalLink={false}
						href={'https://www.prweb.com/releases/mk_decision_and_icba_speak_with_students_at_eastern_kentucky_university_about_community_bank_innovation/prweb16582338.htm'}
						banner={harrai}
						bannerAlt={'Har Rai Khalsa meeting with MK Decision employees'}
						heading={'MK Decision and ICBA Speak with Students at Eastern Kentucky U About Community Bank Innovation'}
						date={'Sep 20, 2019'}
						paragraph={'The speaking event will encourage students to solve the problems local community banks are facing in the era of digitization.'}
					/>

				</div>
				<p><br /><br /><a href='/newsroom-archive/' className='animate-right'>View MK Happenings archive<AngleRight /></a></p>
			</Section>
			<Section className='featured-stories two-columns'>
				<h2 className='blue'>Featured Stories</h2>
				<div className='row row-flush'>
					{/* <LinkArticle
						href={'http://www.prweb.com/releases/mk_decision_selected_to_exhibit_at_2020_startup_grind_global_conference/prweb16887936.htm'}
						banner={startupgrind}
						bannerAlt={'Exhibiting at 2020 Startup Grind'}
						heading={'MK Decision Selected to Exhibit at 2020 Startup Grind Global Conference'}
						date={'Feb 6, 2020'}
						paragraph={'Innovative fintech showcases digital lending platform to attendees from around the world.'}
					/> */}
					<LinkArticle
						href={'https://apnews.com/Business%20Wire/861e245708ee4ae2baffc609885e46d3'}
						banner={ap}
						bannerAlt={'awarded AFT grant'}
						heading={'Four Fintechs Receive Grants from Association for Financial Technology (AFT)'}
						date={'Dec 9, 2019'}
						paragraph={"AP News shares AFT's announcement of their inaugural Fintech Grant Program in partnership with ICBA. "}
					/>
					<LinkArticle
						href={'https://finance.yahoo.com/news/four-fintechs-receive-grants-association-115100840.html'}
						banner={yahoofinance}
						bannerAlt={'awarded AFT grant'}
						heading={'Four Fintechs Receive Grants from Association for Financial Technology (AFT)'}
						date={'Dec 9, 2019'}
						paragraph={"Yahoo! Finance shares AFT's announcement of their inaugural Fintech Grant Program in partnership with ICBA."}
					/>
					<LinkArticle
						href={'http://aftweb.com/aws/AFT/pt/sd/news_article/268856/_PARENT/layout_details/false'}
						banner={aft}
						bannerAlt={'awarded AFT grant'}
						heading={'Four Fintechs Receive Grants from Association for Financial Technology (AFT)'}
						date={'Dec 9, 2019'}
						paragraph={'AFT shares their announcement of the inaugural Fintech Grant Program in partnership with ICBA.'}
					/>
					<LinkArticle
						href={'https://fintecbuzz.com/four-fintechs-receive-grants-from-association-for-financial-technology-aft/'}
						banner={fintechbuzz}
						bannerAlt={'awarded AFT grant'}
						heading={'Four Fintechs Receive Grants from Association for Financial Technology (AFT)'}
						date={'Dec 9, 2019'}
						paragraph={"FinTecBuzz shares AFT's announcement of their inaugural Fintech Grant Program in partnership with ICBA."}
					/>
					<LinkArticle
						href={'https://www.businesswire.com/news/home/20191209005045/en/%C2%A0Four-Fintechs-Receive-Grants-Association-Financial-Technology'}
						banner={businesswire}
						bannerAlt={'awarded AFT grant'}
						heading={'Four Fintechs Receive Grants from Association for Financial Technology (AFT)'}
						date={'Dec 9, 2019'}
						paragraph={'AFT announces their inaugural Fintech Grant Program in partnership with ICBA. MK Decision, Adlumin, Botdoc, and Teslar Software are the four proud recipients of this grant.'}
					/>
					<LinkArticle
						href={'https://bankbeat.biz/payments-guru-mentors-and-inspires/'}
						banner={bankbeatLogoBanner}
						bannerAlt={'featured on BankBeat'}
						heading={'Payments guru mentors and inspires'}
						date={'Dec 4, 2019'}
						paragraph={'Tina Giorgio, ICBA Bancard president and CEO, shares her background in payments, her role models, and how her dedication to mentoring others, including MK Decision, has fostered valuable and long-lasting relationships.'}
					/>
				</div>
				<a href='/newsroom-archive/' className='animate-right'>View Featured Stories archive<AngleRight /></a>
			</Section>
		</div>
	</Layout>;
};

export default NewsroomPage;

export const pageQuery = graphql`
	query {

		site: site {
			siteMetadata {
				endpoint
			}
		}
	}
`;
